module.exports = "<p>\n  kpi-estado-solicitud-base works!\n</p>\n"